<template>
  <div>
    <sections />
  </div>


  
</template>
<script>
import sections from '@/components/formation/sections'


export default {
  components: {
    sections
  }
}
</script>

<style lang="scss">
html{
  scroll-behavior: smooth;
}
</style>
